export default __webpack_public_path__ + "media/zurb/img/experience-design/journey_mapping-ef2bd2dae2e888f82395854fa496a150.png";